<template>
  <v-dialog v-model="internalDialog" max-width="1200px" persistent>
    <v-card>
      <v-card-title class="headline">
        {{ title }}
        <v-spacer />
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-alert
          v-if="alertMessage"
          :type="alertType"
          dense
          outlined
          border="left"
          colored-border
          class="my-4"
        >
          {{ alertMessage }}
        </v-alert>

        <v-alert
          v-if="copyAlert"
          text
          type="info"
          dense
          class="my-2"
        >
          Clave de acceso copiada al portapapeles
        </v-alert>

        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-center">Consecutivo</th>
              <th class="text-center">Recepción</th>
              <th class="text-center">Autorización</th>
              <th class="text-center">Notificación</th>
              <th>Mensaje</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in resultados" :key="`${r.IdCompania}-${r.consecutivo}`">
              <td class="text-center">{{ r.consecutivo }}</td>

              <!-- Estado Recepción -->
              <td class="text-center">
                <v-chip
                  v-if="r.procesamiento"
                  :color="getProcessColor(r.procesamiento.recepcion && r.procesamiento.recepcion.status)"
                  text-color="white"
                  small
                >
                  {{ getProcessText(r.procesamiento.recepcion && r.procesamiento.recepcion.status) }}
                </v-chip>
                <span v-else>-</span>
              </td>

              <!-- Estado Autorización -->
              <td class="text-center">
                <v-chip
                  v-if="r.procesamiento"
                  :color="getProcessColor(r.procesamiento.autorizacion && r.procesamiento.autorizacion.status)"
                  text-color="white"
                  small
                >
                  {{ getProcessText(r.procesamiento.autorizacion && r.procesamiento.autorizacion.status) }}
                </v-chip>
                <span v-else>-</span>
              </td>

              <!-- Estado Notificación -->
              <td class="text-center">
                <v-chip
                  v-if="r.procesamiento"
                  :color="getProcessColor(r.procesamiento.notificacion && r.procesamiento.notificacion.status)"
                  text-color="white"
                  small
                >
                  {{ getProcessText(r.procesamiento.notificacion && r.procesamiento.notificacion.status) }}
                </v-chip>
                <span v-else>-</span>
              </td>

              <!-- Mensaje detallado -->
              <td>
                <div class="text-caption mt-2">
                  {{ getDetailedMessage(r) }}
                </div>
                <div v-if="r.procesamiento && r.procesamiento.autorizacion && r.procesamiento.autorizacion.mensaje_adicional" class="text-caption mt-1">
                  {{ r.procesamiento.autorizacion.mensaje_adicional }}
                </div>
                <div v-if="r.procesamiento && r.procesamiento.recepcion && r.procesamiento.recepcion.clave_acceso" class="text-caption mt-1 mb-2">
                  <strong>Clave acceso:</strong> {{ r.procesamiento.recepcion.clave_acceso }}
                  <v-icon
                    @click="copyClaveAcceso(r.procesamiento.recepcion.clave_acceso)"
                    class="ml-2"
                    color="info darken-3"
                    style="cursor: pointer"
                    small
                  >
                    mdi-content-copy
                  </v-icon>
                </div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ProcessResultsModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    resultados: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: 'Resultados del Procesamiento'
    },
    alertMessage: {
      type: String,
      default: ''
    },
    alertType: {
      type: String,
      default: 'success'
    }
  },
  data() {
    return {
      copyAlert: false
    }
  },
  computed: {
    internalDialog: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.closeModal()
        }
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },

    getProcessColor(status) {
      switch (status) {
        case 'exitoso':
          return 'green'
        case 'error':
          return 'red'
        case 'pendiente':
          return 'orange'
        default:
          return 'grey'
      }
    },

    getProcessText(status) {
      switch (status) {
        case 'exitoso':
          return 'Exitoso'
        case 'error':
          return 'Error'
        case 'pendiente':
          return 'Pendiente'
        default:
          return 'N/A'
      }
    },

    getDetailedMessage(item) {
      if (!item.procesamiento) {
        return item.mensaje || 'Error desconocido'
      }

      const { recepcion, autorizacion, notificacion } = item.procesamiento

      const getErrorMessage = (etapa, data) =>
        `Error en ${etapa}: ${data?.mensaje || 'Error desconocido'}`

      switch (true) {
        case recepcion?.status === 'error':
          return getErrorMessage('recepción', recepcion)

        case autorizacion?.status === 'error':
          return getErrorMessage('autorización', autorizacion)

        case notificacion?.status === 'error':
          return getErrorMessage('notificación', notificacion)

        case recepcion?.status === 'exitoso' &&
            autorizacion?.status === 'exitoso' &&
            notificacion?.status === 'exitoso':
          return 'Documento procesado correctamente'

        case notificacion?.status === 'pendiente':
          return 'Procesamiento completado, notificación pendiente'

        case recepcion?.status === 'exitoso':
          return 'Documento recibido correctamente'

        default:
          return 'Procesamiento en curso'
      }
    },

    async copyClaveAcceso(claveAcceso) {
      try {
        await navigator.clipboard.writeText(claveAcceso)
        this.copyAlert = true
        setTimeout(() => {
          this.copyAlert = false
        }, 3000)
      } catch (e) {
        console.error('No se pudo copiar al portapapeles', e)
      }
    }
  }
}
</script>

<style scoped>
</style>
